module.exports = __webpack_public_path__ + "static/5-0f8407e4d36ec8d8dba84af66143069f.jpg";